import React, { useEffect, useReducer, useRef  } from "react";

// Interface for component props
interface HeadingProps {
	heading: string;
	headingDescription?: string;
	className?: string;
}

export const Heading = ( props: HeadingProps ) => {
	return(
		<div className={"title-body" + (props.className ? (" " + props.className) : "" ) }>
			<p className={"title-body-main"}>{ props.heading }</p>
			<p  className={"title-body-description"}>{ props.headingDescription }</p>
		</div>
	);
};